import _styled from '@emotion/styled/base';
import { InlineDialog } from '@tablekit/inline-dialog';
import { Item } from '@tablekit/item';
import { Spacing } from '@tablekit/theme';
import { Typography } from '@tablekit/typography';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} // the props passed as generic to styled component definition are correct
// the two generic args tend to conflict with each other


var InlineDialogWrapper = /*#__PURE__*/_styled(InlineDialog, process.env.NODE_ENV === "production" ? {
  target: "e105q52t5"
} : {
  target: "e105q52t5",
  label: "InlineDialogWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "jpnmw",
  styles: "height:100%;width:72px;>span{width:100%;}"
} : {
  name: "jpnmw",
  styles: "height:100%;width:72px;>span{width:100%;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Container = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e105q52t4"
} : {
  target: "e105q52t4",
  label: "Container"
})("display:flex;width:500px;flex-wrap:wrap;", Typography.Body2, ";");

var ItemSubtitle = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e105q52t3"
} : {
  target: "e105q52t3",
  label: "ItemSubtitle"
})("margin-left:", Spacing.L1, ";font-size:14px;color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.textSubtle;
}, ";");

var LangItem = /*#__PURE__*/_styled(Item, process.env.NODE_ENV === "production" ? {
  target: "e105q52t2"
} : {
  target: "e105q52t2",
  label: "LangItem"
})("width:", function (_ref2) {
  var itemWidth = _ref2.itemWidth;
  return itemWidth;
}, ";height:", function (_ref3) {
  var itemHeight = _ref3.itemHeight;
  return itemHeight;
}, ";");

var ButtonWrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e105q52t1"
} : {
  target: "e105q52t1",
  label: "ButtonWrapper"
})("text-align:", function (_ref4) {
  var isRtl = _ref4.theme.isRtl;
  return isRtl ? 'left' : 'right';
}, ";padding:", Spacing.L3, ";");

var ScrollWrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e105q52t0"
} : {
  target: "e105q52t0",
  label: "ScrollWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1im0r96",
  styles: "overflow-y:scroll"
} : {
  name: "1im0r96",
  styles: "overflow-y:scroll",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { ButtonWrapper, Container, InlineDialogWrapper, ItemSubtitle, LangItem, ScrollWrapper };
